import { createW3CSignatureIntegrityVerifier } from './w3cModernSignatureIntegrityFactory';

const ecdsaW3CSignatureIntegrity = createW3CSignatureIntegrityVerifier({
  cryptosuite: "ecdsa-sd-2023",
  name: "EcdsaW3CSignatureIntegrity",
  derivationPaths: []
});

export { ecdsaW3CSignatureIntegrity };
